import React from 'react';
import {
  TextField,
  ReferenceManyField,
  Datagrid,
  Pagination,
  SimpleShowLayout,
  BooleanField,
  FunctionField,
} from 'react-admin';
import LinkField from 'components/LinkField';

const BillingGroupsTab = () => (
  <SimpleShowLayout>
    <ReferenceManyField
      pagination={<Pagination />}
      label=""
      reference="LocationBillingGroup"
      target="location_id"
    >
      <Datagrid bulkActionButtons={false}>
        <LinkField label="ID" source="billing_group_id" typename="BillingGroup" />
        <TextField label="Name" source="billing_group.name" />
        <TextField label="Tier" source="billing_group.tier" />
        <FunctionField
          label="Collections Rep"
          render={(record) => {
            if (!record?.billing_group?.collections_representative) {
              return null;
            }
            const accountId = record.billing_group.collections_representative.id;
            return (
              <LinkField to={`/Account/${accountId}/show`}>
                {record.billing_group.collections_representative.name}
              </LinkField>
            );
          }}
        />
        <TextField label="Status" source="billing_group.status" />
        <BooleanField label="Auto Pay" source="billing_group.auto_pay" />
        <TextField label="Plan" source="billing_group.plan" />
        <TextField label="Billing" source="billing_group.billing" />
      </Datagrid>
    </ReferenceManyField>
  </SimpleShowLayout>
);

export default React.memo(BillingGroupsTab);
